// extracted by mini-css-extract-plugin
export default {"root":"Login_root__BunwK","form":"Login_form__cW+Qy"};